// Remembers whether Bootstrap collapse sections marked data-remember-collapse="<key>" were left open or
// closed (per browser, localStorage) and restores that on page load. Used by the compliance dashboards'
// expiring panels and the client and staff compliance detail pages. A collapsed section that the URL's
// #anchor points into is opened. Listeners are bound once on document so they keep working across
// Turbolinks visits.
const STORAGE_KEY = 'collapsedSections';

const loadState = () => {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {};
  } catch (e) {
    return {};
  }
};

const saveState = (key, collapsed) => {
  try {
    const state = loadState();
    state[key] = collapsed;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (e) {
    // Storage unavailable: the section just opens in its default state next time
  }
};

const togglesFor = (section) => document.querySelectorAll(`[data-bs-target="#${section.id}"]`);

['shown.bs.collapse', 'hidden.bs.collapse'].forEach((eventName) => {
  document.addEventListener(eventName, (event) => {
    const section = event.target;
    if (!section.dataset || !section.dataset.rememberCollapse) return;

    saveState(section.dataset.rememberCollapse, eventName === 'hidden.bs.collapse');
  });
});

// Set the state directly (no animation) so the page doesn't visibly open then close
const setCollapsed = (section, collapsed) => {
  section.classList.toggle('show', !collapsed);
  togglesFor(section).forEach((toggle) => {
    toggle.setAttribute('aria-expanded', String(!collapsed));
    toggle.classList.toggle('collapsed', collapsed);
  });
};

// A link to an element inside (or wrapping) a collapsed section, e.g. a dashboard link to one record,
// opens that section for this visit (without changing the remembered state) and scrolls to the element
const openForHash = () => {
  if (!window.location.hash) return;

  let target = null;
  try {
    target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
  } catch (e) {
    return;
  }
  if (!target) return;

  const sections = [target.closest('.collapse')].concat(Array.from(target.querySelectorAll('.collapse')));
  const closed = sections.filter((section) => section && !section.classList.contains('show'));
  if (closed.length === 0) return;

  closed.forEach((section) => setCollapsed(section, false));
  target.scrollIntoView();
};

document.addEventListener('turbolinks:load', () => {
  const state = loadState();
  document.querySelectorAll('[data-remember-collapse]').forEach((section) => {
    const collapsed = state[section.dataset.rememberCollapse];
    if (collapsed === undefined) return;

    setCollapsed(section, collapsed);
  });
  openForHash();
});

window.addEventListener('hashchange', openForHash);
